module.exports = __webpack_public_path__ + "static/media/fixit.c5aea0e9.png";